export const faqs = [
  {
    question: '叮当漫画网上的漫画都是免费的吗？',
    answer: '是的！叮当漫画网所有漫画均为免费阅读，无需付费订阅。我们致力于为广大漫画爱好者提供优质的免费阅读体验，包括全球诡异时代等热门漫画的全部章节均可免费畅读。',
  },
  {
    question: '全球诡异时代漫画多久更新一次？',
    answer: '全球诡异时代漫画目前保持每周更新2-3话的稳定节奏，具体更新时间请关注站内公告和作品页面上的更新日历。作者墨渊老师一直保持着高质量的创作水准。',
  },
  {
    question: '如何找到我想看的漫画分类？',
    answer: '您可以通过顶部导航栏的"分类"菜单浏览所有漫画类别，包括悬疑、恐怖、奇幻、冒险、科幻、热血等。也可以通过首页的分类特色区域或搜索功能快速找到感兴趣的漫画作品。',
  },
  {
    question: '叮当漫画网支持手机阅读吗？',
    answer: '完全支持！叮当漫画网采用响应式设计，在手机、平板和电脑上都能获得流畅的阅读体验。我们特别优化了下拉式阅读模式，让您在手机上也能舒适地追漫。',
  },
  {
    question: '什么是下拉式阅读？',
    answer: '下拉式阅读是一种专为手机和网页优化的漫画阅读方式。所有漫画页面纵向连续排列，您只需向下滑动即可无缝阅读，无需翻页或点击"下一话"按钮，带来最流畅的沉浸式阅读体验。',
  },
  {
    question: '如何联系叮当漫画网的客服？',
    answer: '您可以通过"关于我们"页面上的联系方式与我们取得联系。商务合作请发送邮件至 hello@kjbooks.cn，我们会尽快回复您的咨询。',
  },
];

export const aboutData = {
  brandName: '叮当漫画网',
  founded: '2020年3月',
  mission: '让每一个人都能免费享受漫画的乐趣',
  description: '叮当漫画网成立于2020年，是国内领先的免费漫画阅读平台。我们汇聚了数千部优质漫画作品，涵盖悬疑、恐怖、奇幻、冒险、科幻、热血等多种类型，致力于为漫画爱好者打造最舒适、便捷的在线阅读体验。\n\n平台采用创新的下拉式阅读技术，让读者可以无缝浏览整部漫画，无需繁琐的翻页操作。我们与众多优秀漫画作者合作，持续推出高质量的原创和授权漫画作品，其中《全球诡异时代》已成为平台最受欢迎的代表作品之一。\n\n叮当漫画网始终坚持以用户体验为核心，所有漫画内容完全免费，没有任何隐藏收费。我们的目标是成为中文互联网上最好的免费漫画阅读平台。',
  stats: [
    { icon: 'ri-book-read-line', value: '2,000+', label: '部连载作品' },
    { icon: 'ri-user-heart-line', value: '500万+', label: '日活读者' },
    { icon: 'ri-global-line', value: '覆盖全球', label: '中文读者遍布120+国家' },
  ],
  contact: {
    email: 'hello@kjbooks.cn',
    wechat: 'dingdangmanga',
    siteLink: '@叮当漫画网官方',
    address: '中国广东省广州市天河区体育西路101号叮当漫画大厦',
    phone: '020-8888-6666',
  },
};